import { Component, HostBinding, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ReqService } from '@core/services';
import { IsEconomicPipe } from '@shared/pipes/is-economic.pipe';
import { TotalPriceComponent } from './total-price/total-price.component';
import { PaymentAdviseComponent } from './payment-advise/payment-advise.component';
import { MealPlanComponent } from './meal-plan/meal-plan.component';
import { RoomInformationComponent } from '../hotel-detail-mobile/room-summary/room-information/room-information.component';
import { RoomComponent } from '../room/room.component';
import { MbIconModule } from '@am/moebius';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'detail-cluster',
    templateUrl: './detail-cluster.component.html',
    styleUrls: ['./detail-cluster.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        MbIconModule,
        RoomComponent,
        NgFor,
        RoomInformationComponent,
        MealPlanComponent,
        PaymentAdviseComponent,
        TotalPriceComponent,
        IsEconomicPipe,
    ],
})
export class DetailClusterComponent implements OnInit, OnChanges {
  @HostBinding('class.prioritized-cluster-border')
  get prioritizedTag(): boolean {
    return this.isExperts && this.cluster?.prioritized_by_rate_filter;
  }
  @Input()
  hotelAvailabilityInfo: any;
  @Input()
  priceByValue: any;
  @Input()
  cluster: any;
  @Input()
  index: any;
  @Input()
  showAmountTotal: any;
  @Input()
  hotelStaticInfo: any;
  @Input()
  isHomestay: boolean;

  public pricesModel: any;
  public rateOption: any;
  public isAlliance: boolean;
  public userCountry: string;
  public bedInfo: any;
  public isArgentina: boolean;
  public isExperts: boolean;

  constructor(
    private reqService: ReqService,
  ) {}

  ngOnInit() {
    this.pricesModel = {};
    this.rateOption = { id: 0 };
    this.userCountry = this.reqService.getCountry();
    this.isAlliance = this.reqService.isAlliance();
    this.bedInfo = this.hotelAvailabilityInfo.rooms_detail
      ? this.hotelAvailabilityInfo.rooms_detail.find(
          (roomDetail) => roomDetail.id === this.cluster.rooms[0].id,
        )
      : '';
    this.isArgentina = ['1123215', 'NEW8'].includes(
      this.hotelAvailabilityInfo.country.id,
    );
    this.isExperts = this.reqService.isExperts();
  }

  ngOnChanges(_changes: SimpleChanges) {
    this.bedInfo = this.hotelAvailabilityInfo.rooms_detail
      ? this.hotelAvailabilityInfo.rooms_detail.find(
        (roomDetail) => roomDetail.id === this.cluster.rooms[0].id,
      )
      : '';
  }
}
